module.exports = __webpack_public_path__ + "img/20250417_MolecularCell.890075b9.jpg";